import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { class: "component-variable-value-v2 component-variable-value--color" };
const _hoisted_2 = { class: "form color-input-wrapper-form" };
import { computed } from "vue";
import { ElColorPicker, ElInput } from "element-plus";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ColorComponentVariableRawValue',
    props: {
        modelValue: {}
    },
    emits: ["update:modelValue"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const isString = (value) => {
            return typeof value === "string";
        };
        const valueProxy = computed({
            get() {
                return isString(props.modelValue) ? props.modelValue : "";
            },
            set(value) {
                emit("update:modelValue", value);
            },
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("form", _hoisted_2, [
                    _createVNode(_unref(ElInput), {
                        modelValue: valueProxy.value,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((valueProxy).value = $event))
                    }, null, 8 /* PROPS */, ["modelValue"]),
                    _createVNode(_unref(ElColorPicker), {
                        modelValue: valueProxy.value,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((valueProxy).value = $event)),
                        size: "large"
                    }, null, 8 /* PROPS */, ["modelValue"])
                ])
            ]));
        };
    }
});
